import { render, staticRenderFns } from "./Demo2.vue?vue&type=template&id=1bc6232d&scoped=true"
import script from "./Demo2.vue?vue&type=script&lang=js"
export * from "./Demo2.vue?vue&type=script&lang=js"
import style0 from "./Demo2.vue?vue&type=style&index=0&id=1bc6232d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc6232d",
  null
  
)

export default component.exports